import React from "react";

const FlpConsentLP = ({ showConsent, handleclick }) => {
    return (
        <>
            <section className={"banner " + (showConsent === 'show' ? 'hide' : '')}>
                <div className="container">
                    <div>
                        <div className="brand">
                            <div className="logo pt-3">
                                <img src="assets/img/logo_1.png" height={60} alt="" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="banner-inner">
                            <div className="row  ">
                                <div className="col-lg-8 col-md-12 col-sm-12">
                                    <div className="banner-caption">
                                        <div className=" mt-lg-0 mt-md-2 mt-sm-4 mt-5">
                                            <div className="overflow-hidden ">
                                                <h1 className="fw-bold  drop-in text-lg-start text-md-center text-sm-center text-center  ">
                                                    You&nbsp;Could&nbsp;Be&nbsp;Owed&nbsp;More. Take the
                                                    Next Step
                                                </h1>
                                            </div>
                                            <div className="overflow-hidden">
                                                <p className="  pt-0 drop-in-2 subtext text-lg-start text-md-center text-sm-center text-center">
                                                    We’ve found potential opportunities to claim more
                                                    compensation without affecting your current case.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mt-lg-3 overflow-hidden tex-lg-start text-md-start text-sm-center text-center mt-lg-3 mt-md-3 mt-sm-0 mt-3">
                                            <div>
                                                <div className="row">
                                                    <div className="col-lg-11">
                                                        <div className="overflow-hidden ">
                                                            <div className="drop-in-2">
                                                                <button
                                                                    className="btn-comm2 px-5 fw-semibold pulse2 my-2 mx-2 chooseLender  "
                                                                    onClick={handleclick}
                                                                >
                                                                    {" "}
                                                                    Proceed
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="overflow-hidden">
                                                <div className=" mt-4 list-style-wrap drop-in-2">
                                                    <h4>Why This Matters</h4>
                                                    <ul className="ps-0 mt-4  list-style text-start">
                                                        <li>
                                                            <span>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-check-circle"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                                                </svg>
                                                            </span>
                                                            You may be owed <strong>£1,000</strong>s more
                                                            per car loan
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-check-circle"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                                                </svg>
                                                            </span>
                                                            It’s quick, easy, and handled by a trusted legal
                                                            partner
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-check-circle"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                                                </svg>
                                                            </span>
                                                            You stay in control, nothing is committed
                                                            without your approval
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12  ">
                                    <div className="man-art d-lg-block d-md-none d-sm-none d-none">
                                        <img src="assets/img/steps.png" alt="" />
                                    </div>
                                </div>
                                <div className="text-center man-art-mobile d-lg-none d-md-block d-sm-block d-block">
                                    <img src="assets/img/steps.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FlpConsentLP;